@import "tailwindcss";

html,
body,
#root {
  min-height: 100%;
  margin: 0;
}

body {
  background: #f3f4f6;
  color: #1f2937;
  font-family: 'Segoe UI', 'Hiragino Sans', 'Meiryo', sans-serif;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}

input,
select,
textarea {
  font-family: inherit;
}

input[type='checkbox'],
input[type='radio'] {
  width: 1.05rem;
  height: 1.05rem;
  min-width: 1.05rem;
  min-height: 1.05rem;
  flex-shrink: 0;
  accent-color: #2563eb;
  cursor: pointer;
}

input[type='checkbox']:disabled,
input[type='radio']:disabled {
  cursor: not-allowed;
}

label:has(input[type='checkbox']) {
  line-height: 1.55;
}

/* 入力欄の一貫したフォーカス/ホバー/トランジション（version2 .fld 準拠） */
.fld {
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;
}
.fld:hover:not(:disabled):not(:focus) {
  border-color: #9ca3af;
}
.fld:focus {
  background-color: #fff;
}

/* セクション番号バッジ（version2 .sec-badge 準拠） */
.sec-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 0.6rem;
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  color: #fff;
  font-weight: 700;
  font-size: 0.9rem;
  box-shadow: 0 2px 6px rgba(37, 99, 235, 0.35);
  flex-shrink: 0;
}

/* セレクトの矢印を上品なシェブロンに差し替え（version2 select.sel 準拠） */
select.sel {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none' stroke='%236b7280' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M4 6l4 4 4-4'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 0.65rem center;
  background-size: 1.05rem;
  padding-right: 2.25rem;
}
select.sel::-ms-expand {
  display: none;
}

/* ステップインジケータ（装飾のみ・version2 準拠） */
.stepbar {
  display: flex;
  align-items: center;
  gap: 6px;
}
.step-dot {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
  border: 1.5px solid #cbd5e1;
  color: #94a3b8;
  background: #fff;
  transition: all 0.2s ease;
}
.step-dot.active {
  border-color: #2563eb;
  color: #fff;
  background: #2563eb;
}
.step-dot.done {
  border-color: #2563eb;
  color: #2563eb;
  background: #eff6ff;
}
.step-line {
  flex: 1 1 auto;
  height: 2px;
  border-radius: 2px;
  background: #cbd5e1;
  min-width: 8px;
}
.step-line.done {
  background: #2563eb;
}
.step-label {
  font-size: 10px;
  color: #94a3b8;
  font-weight: 600;
}
.step-label.active {
  color: #1d4ed8;
}

@keyframes cardIn {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}
.card-in {
  animation: cardIn 0.35s ease both;
}

@media print {
  .no-print {
    display: none !important;
  }

  .print-break {
    break-inside: avoid;
  }
}

/* インラインエラー（version2 .inline-error 準拠：赤い●＋11px の赤文字） */
.customer-inline-error {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  margin-top: 4px;
  color: #dc2626;
  font-size: 11px;
  line-height: 1.3;
}
.customer-inline-error::before {
  content: "●";
  font-size: 9px;
  font-weight: 900;
  line-height: 1.3;
  margin-top: 1px;
}

@keyframes toastSlideUp {
  from { opacity: 0; transform: translateY(16px); }
  to { opacity: 1; transform: translateY(0); }
}
